import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-72f5c130"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "el-menu--horizontal"
};
import { ref, watch } from "vue";
import store from "@/store";
export default /*#__PURE__*/_defineComponent({
  __name: 'associationheader',
  setup(__props) {
    watch(() => store.state.amenu, (newVal, oldVal) => {
      activeIndex2.value = newVal;
    });
    const activeIndex2 = ref("/webpage/association/overview");
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_menu, {
        "default-active": activeIndex2.value,
        class: "el-menu-demo",
        mode: "horizontal",
        "background-color": "grey",
        "text-color": "#fff",
        "active-text-color": "#ffd04b",
        router: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "/webpage/association/overview"
        }, {
          default: _withCtx(() => [_createTextVNode("协会概况")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/association/leaders"
        }, {
          default: _withCtx(() => [_createTextVNode("协会领导")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/association/trends/协会新闻"
        }, {
          default: _withCtx(() => [_createTextVNode("协会动态")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/association/members/常务理事单位"
        }, {
          default: _withCtx(() => [_createTextVNode("会员风采")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/association/service"
        }, {
          default: _withCtx(() => [_createTextVNode("会员服务")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/association/policys/国家政策"
        }, {
          default: _withCtx(() => [_createTextVNode("政策法规")]),
          _: 1
        })]),
        _: 1
      }, 8, ["default-active"])]);
    };
  }
});